// extracted by mini-css-extract-plugin
export default {"sidebar":"MockupPreview_sidebar__O87lt","content":"MockupPreview_content__Fisom","image":"MockupPreview_image__zk0c2"};